export const WHATSAPP_NUMBER = "5554999627792"; // Eronilde

export function waLink(message = "Olá Avantech, gostaria de mais informações.") {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
}

export const CONTACTS = {
  eronilde: { name: "Eronilde", phone: "5554999627792", display: "(54) 99962-7792" },
  aline: { name: "Aline", phone: "5554999043988", display: "(54) 99904-3988" },
  vera: { name: "Vera", phone: "5554997079765", display: "(54) 99707-9765" },
};
